import React, { useState } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { BtnThemMoi } from "../DanhSachKhachHang/ThemMoiVaSua/BtnThemMoi";
import { BtnNguonKhachHang } from "../DanhSachKhachHang/NguonKhachHang/BtnNguonKhachHang";
import { BtnXuatDanhSachKhachHang } from "../DanhSachKhachHang/XuatExcel/BtnXuatDanhSachKhachHang";
import { pushNotification } from "utils/notifications";
import { BtnSua } from "../DanhSachKhachHang/ThemMoiVaSua/BtnSua";
import { BtnXoa } from "../DanhSachKhachHang/Xoa/BtnXoa";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload, listTinhTrang, listCuaHang, onOpenModalNguonKH }) => {

    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const scrollToTop = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    const handlePageChange = (pageNumber) => {
        const newSearchData = { ...dataSearch, pageIndex: pageNumber };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
        setSelectedCustomer(null);
        scrollToTop();
    };

    const handlePageSizeChange = (pageSize) => {
        const newSearchData = { ...dataSearch, pageSize, pageIndex: 1 };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
        setSelectedCustomer(null);
        scrollToTop();
    };

    const handleEditWrapper = (e) => {
        if (!selectedCustomer) {
            pushNotification("Vui lòng chọn một khách hàng để sửa!", "warning");
            e.stopPropagation();
        }
    };

    const handleDeleteWrapper = (e) => {
        if (!selectedCustomer) {
            pushNotification("Vui lòng chọn một khách hàng để xóa!", "warning");
            e.stopPropagation();
        }
    };

    const shouldShowDeleteBtn = !selectedCustomer || (selectedCustomer && selectedCustomer.IsDelete === 1);

    return (
        <>
            {isLoading ? (
                <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-1" style={{ position: 'relative' }}>
                                <BtnThemMoi onReload={onReload} />
                                <div className="d-flex align-items-center gap-2 ml-1">
                                    <div className="mr-1"><BtnNguonKhachHang onClick={onOpenModalNguonKH} /> </div>
                                    {phanQuyen.danhsachkhachhang_suakhachhang && (
                                        <div onClickCapture={handleEditWrapper} className="mr-1">
                                            <BtnSua item={selectedCustomer || {}} onReload={onReload} />
                                        </div>
                                    )}
                                    {shouldShowDeleteBtn && (
                                        <div onClickCapture={handleDeleteWrapper}>
                                            <BtnXoa item={selectedCustomer || {}} onReload={onReload} />
                                        </div>
                                    )}
                                </div>
                                <div style={{ position: 'absolute', right: '0', display: 'flex', gap: '10px' }} className="hidden-mobile-main">
                                    {phanQuyen.danhsachkhachhang_xuatdanhsachkhachhangrafileexcel &&(
                                       <BtnXuatDanhSachKhachHang filters={dataSearch} />
                                    )}
                                </div>
                                <div style={{ position: 'absolute', right: '0' }} className="hide-table-main show-mobile-main hidden-des-main">   
                                    {phanQuyen.danhsachkhachhang_xuatdanhsachkhachhangrafileexcel &&(
                                       <BtnXuatDanhSachKhachHang filters={dataSearch} style={{ marginTop: 40 }} />
                                    )}
                                </div>
                            </div>
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers word-break" style={{ alignItems: 'stretch' }}>
                                            <div className="custom-table-header text-center flex-basis-7 flex-basis-7-sm" style={{ justifyContent: 'center', fontSize: '15px' }}>
                                                <p className="color-do-bold">STT <br />[{listDanhSach.iTotal}]</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-16 flex-basis-16-sm" style={{ justifyContent: 'flex-start', fontSize: '15px' }}>
                                                <p>Tên khách hàng</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-14 flex-basis-14-sm" style={{ fontSize: '15px' }}>
                                                <p>Cửa hàng</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-8 flex-basis-8-sm" style={{ fontSize: '15px' }}>
                                                <p>Ngày sinh</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ fontSize: '15px' }}>
                                                <p>Số CCCD</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-start', fontSize: '15px' }}>
                                                <p>Địa chỉ</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ fontSize: '15px' }}>
                                                <p>Đối tác</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center', fontSize: '15px' }}>
                                                <p>Tình trạng</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center', fontSize: '15px' }}>
                                                <p>Ảnh</p>
                                            </div>
                                        </div>
                                        <div className="custom-table-body">
                                            <ContentTable
                                                listDanhSach={listDanhSach.List}
                                                phanQuyen={phanQuyen}
                                                onReload={onReload}
                                                dataSearch={dataSearch}
                                                listTinhTrang={listTinhTrang}
                                                listCuaHang={listCuaHang}
                                                selectedCustomer={selectedCustomer}
                                                setSelectedCustomer={setSelectedCustomer}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {listDanhSach.iTotal > 0 && (
                        <div className="card border-light mb-2 card-v2">
                            <div className="card-body card-body-v2">
                                <PhanTrang
                                    pageIndex={dataSearch.pageIndex}
                                    pageSize={dataSearch.pageSize}
                                    totalCount={listDanhSach.iTotal}
                                    onPageChange={handlePageChange}
                                    onPageSizeChange={handlePageSizeChange}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};